module.exports = __webpack_public_path__ + "img/originalosteo.4c98eaaf.jpg";